import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TournamentsPage from "@/pages/TournamentsPage";
import CourtsPage from "@/pages/CourtsPage";
import TournamentDetailPage from "@/pages/TournamentDetailPage";
import RankingsPage from "@/pages/RankingsPage";
import AthleteProfilePage from "@/pages/AthleteProfilePage";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import TrainingPage from "@/pages/TrainingPage";
import DataVolleyPage from "@/pages/DataVolleyPage";
import LandingPage from "@/pages/LandingPage";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/academy" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/naos" element={<DataVolleyPage />} />
            <Route path="/tournaments" element={<TournamentsPage />} />
            <Route path="/courts" element={<CourtsPage />} />
            <Route path="/tournaments/:slug" element={<TournamentDetailPage />} />
            <Route path="/rankings" element={<RankingsPage />} />
            <Route path="/athletes/:id" element={<AthleteProfilePage />} />
            <Route path="/datavolley" element={<Navigate to="/naos" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: { fontFamily: "Manrope, sans-serif" },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
